/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function t(t){return"object"==typeof t&&"function"==typeof t.start}export{t as isAnimationControls};
//# sourceMappingURL=is-animation-controls.js.map
